import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AvsAppBar from './components/Generic/appBar/appBar';
import HomePage from './pages/HomePage';
import BlogPost from './pages/BlogPost';
import UseCasePost from './pages/UseCasePost';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#345995',
    },
    secondary: {
      main: '#3498db',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <div className="App">
                <AvsAppBar />
                <HomePage />
              </div>
            }
          />
          {/* e.g. /blog/train-the-mind — slug is kebab-case from the post title */}
          <Route
            path="/blog/:slug"
            element={
              <div className="App">
                <AvsAppBar />
                <BlogPost />
              </div>
            }
          />
          <Route
            path="/agentic/:slug"
            element={
              <div className="App">
                <AvsAppBar />
                <UseCasePost />
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
